import axios from 'axios'
import { Message } from 'element-ui'
import Auth from '@/store/modules/auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

service.interceptors.request.use(
  (config) => {
    config.headers.accept = 'application/json'

    config.headers['content-type'] = 'application/json'

    if (Auth.state.token) {
      config.headers.Authorization = 'Bearer ' + Auth.state.token
    }

    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    if (response.data.success !== undefined) {
      Message({
        message: response.data.success,
        type: 'success',
        duration: 5 * 1000
      })
    }

    return response
  },
  (error) => {
    let message = ''

    if (error.response.data.errors !== undefined) {
      const k = Object.keys(error.response.data.errors)[0]

      message = error.response.data.errors[k][0]
    } else if (error.response.data.message !== undefined) {
      message = error.response.data.message
    } else if (error.response.data.error !== undefined) {
      message = error.response.data.error
    } else {
      message = error.message
    }

    Message({
      message: message,
      type: 'error',
      duration: 5000
    })

    return Promise.reject(error)
  }
)

export default service
